<template>
  <div></div>
</template>
<script>
import { COUPON_PROVIDER } from '@/store/types'
export default {
  name: 'AutoTrialReceive',
  data() {
    return {
      code: this.$route.params.code
    }
  },
  mounted() {
    if (this.code != null) {
      // 받은 도서코드로 API에서 체험판 발급.
      this.$store
        .dispatch(COUPON_PROVIDER, { code: this.code })
        .then((res) => {
          if (res.data.ok) {
            // console.log('테스트 - 성공라인')
            this.$router.push({ name: 'library_default' })
          }
        })
        .catch((err) => {
          if (err) {
            // console.log('테스트 - 실패라인')
            alert(err.response.data.errorState.message)
            this.$router.push({
              name: 'library_default'
            })
          }
        })
    } else {
      alert('error!')
      this.$router.push({ name: 'store' })
    }
  }
}
</script>
<style lang="scss" scoped></style>
